import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentApprovalPreviewComponent } from './document-approval-preview/document-approval-preview.component';
import { CoreModule } from '../../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RadioButtonModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';
import { CustomerService } from '../../services/customer.service';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    PdfViewerModule,
    RadioButtonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [DocumentApprovalPreviewComponent],
  providers: [CustomerService],
})
export class DocumentApprovalModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-approval/document-approval.module.ts